import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL } from '@sorare/core/src/atoms/typography';
import { Video } from '@sorare/core/src/atoms/ui/Video';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';

import av1 from './assets/SORARE-101VIDEO.av1.webm';
import h264 from './assets/SORARE-101VIDEO.h264.mp4';
import vp9 from './assets/SORARE-101VIDEO.vp9.webm';
import poster from './assets/newLandingPoster.webp';

const sources = [
  { src: av1, type: 'video/webm; codecs="av01.0.31M.08,opus"' },
  { src: vp9, type: 'video/webm; codecs="vp9"' },
  { src: h264 },
];

const VideoWrapper = styled.div`
  border-radius: var(--unit);
  width: calc(80 * var(--vw));
  overflow: hidden;
`;

export const HowToPlay = () => {
  const isLaptop = useIsLaptop();
  return (
    <Vertical gap={isLaptop ? 6 : 2} center>
      <BrandL>
        <FormattedMessage
          id="Press.HowToPlay.title"
          defaultMessage="How to play"
        />
      </BrandL>
      <VideoWrapper>
        <Video sources={sources} muted poster={poster} />
      </VideoWrapper>
    </Vertical>
  );
};
